import React, { useState, useContext, useEffect } from "react";
import {
	Box,
	Typography,
	Button,
	TextField,
	Grid,
	Divider,
	FormControlLabel,
	Checkbox,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Product1 from "../../assets/product1.png";
import Product2 from "../../assets/product2.png";
import Product3 from "../../assets/product3.png";
import Product4 from "../../assets/product4.png";
import Product5 from "../../assets/product5.png";
import Product6 from "../../assets/product6.png";
import Product7 from "../../assets/product7.png";
import Product8 from "../../assets/product8.png";
import Product9 from "../../assets/product9.png";
import Product10 from "../../assets/product10.png";
import Product11 from "../../assets/product11.png";
import Product12 from "../../assets/product12.png";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";

const ShowcaseAddress = ({
	sector,
	useCoupon,
	cartShippingMethod,
	cartShippingAddress,
	cartShippingBillingAddress,
	cartCreditCard,
	showBilling,
}) => {
	const { t } = useTranslation();
	const { creator } = useContext(CreatorContext);
	const [content, setContent] = useState([]);

	// Estado para el código de descuento
	const [discountCode, setDiscountCode] = useState("");

	useEffect(() => {
		// Cargar productos específicos del sector
		const loadCartItems = () => {
			switch (sector) {
				case "ecommerce":
					setContent([
						{
							name: t("homeProducts.sunsetBlueSweater"),
							price: "€18.99",
							image: Product1,
							quantity: 1,
						},
						{
							name: t("homeProducts.oversizePinkSweater"),
							price: "€25.99",
							image: Product3,
							quantity: 1,
						},
					]);
					break;
				case "restaurant":
					setContent([
						{
							name: t("menuItems.pepperoniPizza"),
							price: "€8.00",
							image: ProductRestaurant1,
							quantity: 2,
						},
						{
							name: t("menuItems.cheesePizza"),
							price: "€8.00",
							image: ProductRestaurant2,
							quantity: 1,
						},
					]);
					break;
				default:
					setContent([]);
					break;
			}
		};
		loadCartItems();
	}, [sector, t]);

	// Función para calcular el total
	const calculateTotal = () => {
		switch (sector) {
			case "ecommerce":
				return "€44.98";
			case "restaurant":
				return "€44.98";

			default:
				return "€18";
		}
	};

	function hexToRGBA(hex, opacity) {
		let r = parseInt(hex.slice(1, 3), 16);
		let g = parseInt(hex.slice(3, 5), 16);
		let b = parseInt(hex.slice(5, 7), 16);

		return `rgba(${r}, ${g}, ${b}, ${opacity})`;
	}

	const ShippingAddress = () => {
		const [checked, setChecked] = useState(false);

		const { creator } = useContext(CreatorContext);

		const address = {
			name: "Jane Smith",
			line1: "Mallorca 125, 2nd floor, door A",
			city: "Barcelona",
			zip: "08008",
			country: "Spain",
			phone: "0034 230 923 03",
		};

		return (
			<Box sx={{}}>
				<Typography variant="body2" gutterBottom>
					{showBilling ? cartShippingBillingAddress : cartShippingAddress}
				</Typography>
				<Box
					sx={{
						display: "flex",
						flexDirection: "row",
						gap: 1,
						alignItems: "center",
					}}
				>
					<CheckBoxIcon sx={{ fontSize: "14px" }} />
					<Box sx={{ display: "flex", flexDirection: "column" }}>
						<Typography
							variant="body2"
							sx={{ fontWeight: "bold", fontSize: "8px" }}
						>
							{address.name}
						</Typography>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{address.line1}
						</Typography>
						<Typography
							variant="body2"
							sx={{ fontSize: "8px" }}
						>{`${address.city}, ${address.zip} - ${address.country}`}</Typography>
						<Typography variant="body2" sx={{ fontSize: "8px" }}>
							{address.phone}
						</Typography>
					</Box>
				</Box>
			</Box>
		);
	};

	return (
		<Box
			sx={{
				padding: 1,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between",
				height: "100%",
			}}
		>
			<ShippingAddress />

			<Box>
				<Button
					variant="contained"
					fullWidth
					sx={{
						color: hexToRGBA("#000000", 0.6),
						border: `1px solid ${hexToRGBA("#000000", 0.2)}`,
						backgroundColor: "#ffffff",
						"&:hover": {
							backgroundColor: "#ffffff",
						},
						fontSize: "8px",
						borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
						fontWeight: "bold",
						textTransform: "uppercase",
						height: "28px",
						width: "100%",
					}}
				>
					{t("cart.addAddress")}
				</Button>
				<Divider sx={{ marginTop: 1, marginBottom: 1 }}></Divider>
				<Box sx={{ display: "flex", justifyContent: "space-between" }}>
					<Typography
						variant="body2"
						sx={{
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.shipping")}
					</Typography>
					<Typography
						variant="body2"
						sx={{ fontSize: "8px", textTransform: "inherit" }}
					>
						-
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: 1,
					}}
				>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{t("cart.total")}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							fontWeight: "bold",
							fontSize: "8px",
							textTransform: "inherit",
						}}
					>
						{calculateTotal()}
					</Typography>
				</Box>

				<Button
					variant="contained"
					fullWidth
					sx={{
						backgroundColor: creator ? creator.color : "#45A049",
						"&:hover": {
							backgroundColor: creator ? creator.color : "#45A049",
						},
						color: creator && creator.whiteTextButton ? "#ffffff" : "#000000",
						fontSize: "8px",
						borderRadius: creator && creator.buttonRounded ? "24px" : "0px",
						fontWeight: "bold",
						textTransform: "uppercase",
						height: "28px",
						width: "100%",
					}}
				>
					{t("cart.continueOrder")}
				</Button>
			</Box>
		</Box>
	);
};

export default ShowcaseAddress;
